import { useState } from "react";
import { observer } from "mobx-react";
import { useStores } from "@hooks";
import { getTeamMembersQuery } from "@query";
import { PageTitle, Tag } from "@components";
import { Container } from "@material-ui/core";
import { TeamView } from "./TeamView";
import { SeatsCounterDetails } from "./components";

export const Team = observer(() => {
  const { userStore } = useStores();
  
  const [ isLoading, setIsLoading ] = useState(true);
  const [ users, setUsers ] = useState([]);
  
  const { isManager } = userStore;
  const { premiumUsers } = userStore.subscriptionInfo;
  
  const loadData = async () => {
    if (!isLoading)
      setIsLoading(true);
    
    const res = await getTeamMembersQuery();
    setUsers(res);
    
    setIsLoading(false);
  };
  
  return (
    <>
      <PageTitle
        pinned
        titleTag={
          isManager &&
          <Tag
            text={`${users.length}/${premiumUsers.length < 0 ? "∞" : premiumUsers }`}
            className="ml-3 mt-1"
          />
        }
      >
        {
          isManager &&
          <SeatsCounterDetails
            isLoading={isLoading}
            users={users.length}
            onInvite={loadData}
            useActionButton
          />
        }
      </PageTitle>
      <Container>
        <TeamView
          handleLoad={loadData}
          users={users}
        />
      </Container>
    </>
  );
});
